module.exports = __webpack_public_path__ + "static/img/blogpost.1e056c28.jpg";